import type { ImageProps } from "@mantine/core"
import type { TActivity } from "@/types"
import { ImageWithPlaceholder } from "../utils"
import { ActivityImagePlaceholder } from "./ActivityImagePlaceholder"

export function ActivityImage({
  h = 120,
  radius,
  activity,
  ...props
}: { activity: TActivity } & Omit<ImageProps, "src">) {
  return (
    <ImageWithPlaceholder
      h={h}
      radius={radius}
      alt={activity.title}
      src={activity.picture || ""}
      placeholder={<ActivityImagePlaceholder activity={activity} radius={radius} h={h} />}
      {...props}
    />
  )
}
